var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilePolicy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z",
    fill: "#E3F2FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 11.3333H14.0001C13.6465 11.3333 13.3073 11.4737 13.0573 11.7238C12.8072 11.9738 12.6667 12.313 12.6667 12.6666V23.3333C12.6667 23.6869 12.8072 24.026 13.0573 24.2761C13.3073 24.5261 13.6465 24.6666 14.0001 24.6666H22.0001C22.3537 24.6666 22.6928 24.5261 22.9429 24.2761C23.1929 24.026 23.3334 23.6869 23.3334 23.3333V14.6666L20.0001 11.3333Z",
    stroke: "#1565C0",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 11.3333V13.9999C19.3333 14.3535 19.4737 14.6927 19.7238 14.9427C19.9738 15.1928 20.313 15.3333 20.6666 15.3333H23.3333",
    stroke: "#1565C0",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 16H15.3333",
    stroke: "#1565C0",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 18.6667H15.3333",
    stroke: "#1565C0",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 21.3333H15.3333",
    stroke: "#1565C0",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePolicy);
export default __webpack_public_path__ + "static/media/filePolicy.540eca3855a6e6d1a8f0b2b49c65588b.svg";
export { ForwardRef as ReactComponent };